export const createUserServices = (coreServices) => {
  return {
    /** Delete user
     * @param {int} userId User id to delete
     */
    deleteUser(userId, commentary) {
      return coreServices.delete(`/users/${userId}/`, {commentary});
    },
    getMe() {
      return coreServices.get('/users/me/');
    },
    getUserHistory({ page = 1, page_size = 25, search } = {}) {
      const params = { page, page_size };
      if (search) params.search = search;
      return coreServices.get('/users/history/', params);
    },
    /** Get list of users */
    getUsers() {
      return coreServices.get('/users/');
    },
    /** Create a new user
     * @param {Object} data dictionary of the user
     */
    createUser(data) {
      return coreServices.post('/users/', data);
    },
    /** Update a user
     * @param {Object} data dictionary of the user
     * @param {int} userId User id to update
     */
    updateUser(userId, data) {
      return coreServices.put(`/users/${userId}/`, data);
    },
    /*
      Account-App documentation
    */
    getDocumentationProfile() {
      return coreServices.get('/users/documentation/');
    },
    deleteDocumentationProfile(docId) {
      return coreServices.delete(`/users/documentation/${docId}/`);
    },
    createDocumentationProfile(data) {
      const headers = coreServices.getMultipartRequestHeader();
      return coreServices.post('/users/documentation/', data, headers);
    },
    updateDocumentationProfile(docId, data) {
      const headers = coreServices.getMultipartRequestHeader();
      return coreServices.put(`/users/documentation/${docId}/`, data, headers);
    },
    getMyDocumentationProfile() {
      return coreServices.get('/users/documentation/my-docs/');
    },
    getDocumentationProfileUrl(documentId) {
      return coreServices.get(`/users/documentation/${documentId}/url/`);
    },
    markDocumentationProfileRead(documentId) {
      return coreServices.put(`/users/documentation/${documentId}/read/`);
    },
    sendEmailFeedback(archive, feedbackComment) {
    const headers = coreServices.getRequestHeader({
      'Content-Type': 'multipart/form-data',
    });
    const data = new FormData();
    data.append('feedback', feedbackComment);
    if (archive) {
      data.append('title', archive.name);
      data.append('file_data', archive);
      data.append('file_type', archive.type);
    }
    return coreServices.post('/users/send-email-feedback/', data, headers);
  },
  };
};
